import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.853 10 3.566 8.713a3.64 3.64 0 1 1 5.147-5.147l7.721 7.72a3.64 3.64 0 0 1-5.147 5.148L8.39 13.539a2.275 2.275 0 0 1 3.217-3.217l1.609 1.608"
    />
  </svg>
)
export default SvgComponent
